import { useEffect } from 'react';

/**
 * Redirects to an absolute (external) URL using window.location.replace
 * so the browser performs a true navigation rather than a client-side route push.
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}